export default {
  ASSESSMENT: 'ASSESSMENT',
  ORDERS: 'ORDERS',
  SETUP_TREATMENT: 'SETUP_TREATMENT',
  ADD_TRACKING: 'ADD_TRACKING',
} as const
